var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWPageLink0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.315C9.91189 14.315 8.21289 12.617 8.21289 10.529C8.21289 8.44099 9.91289 6.73999 11.9999 6.73999C14.0869 6.73999 15.7869 8.43999 15.7869 10.527C15.7869 12.614 14.0869 14.312 11.9999 14.312V14.315ZM11.9999 8.24199C10.7399 8.24199 9.71289 9.26799 9.71289 10.529C9.71289 11.79 10.7399 12.814 11.9999 12.814C13.2599 12.814 14.2869 11.789 14.2869 10.528C14.2869 9.26699 13.2599 8.23999 11.9999 8.23999V8.24199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6921 10.69C20.6921 5.9 16.7921 2 12.0001 2C7.20811 2 3.30811 5.9 3.30811 10.69C3.30811 12.592 3.91111 14.398 5.05111 15.913L5.05411 15.911L5.06111 15.926C6.68911 17.996 11.3391 21.683 11.5361 21.838C11.6741 21.948 11.8381 22.001 12.0011 22.001C12.1641 22.001 12.3281 21.948 12.4661 21.839C12.6631 21.684 17.3131 17.999 18.9411 15.927L18.9481 15.913L18.9501 15.915C20.0901 14.399 20.6921 12.595 20.6921 10.692V10.69ZM12.0001 20.29C10.7761 19.3 7.48011 16.575 6.24411 15.005C5.30411 13.755 4.80811 12.263 4.80811 10.693C4.80811 6.727 8.0351 3.5 12.0001 3.5C15.9651 3.5 19.1921 6.726 19.1921 10.69C19.1921 12.26 18.6951 13.752 17.7561 15.003C16.5201 16.573 13.2241 19.297 12.0001 20.288V20.29Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWPageLink0);
export default __webpack_public_path__ + "static/media/w-page-link-0.e31b142f574aab2f1b0685e09bad069a.svg";
export { ForwardRef as ReactComponent };